/**
 * Fixed catalog identity (Module 24) — product-id *strings*, not remote-config, since
 * these must match whatever's configured in the real Play Console/RevenueCat
 * dashboard; they're not a tunable reward value like the coin/gem amounts each pack
 * grants (those live in remote-config, see packages/remote-config/src/constants.ts's
 * IAP_PACK_* keys).
 *
 * These are real, already-live Play Console one-time product IDs (from the
 * `puzzlemaniastudio.puzzlemania` app, originally listed under an older "itemsort"
 * game name — reused here rather than creating new Play Console products). A 4th
 * existing product, "Promo Pack Of Gems" (`..._pack_1`), is deliberately left unused —
 * this catalog stays a fixed 3-tier Small/Medium/Large scheme.
 */
export const IAP_PRODUCT_IDS = {
    SMALL: 'puzzlemaniastudio.puzzlemania.itemsort.gems_pack_2',
    MEDIUM: 'puzzlemaniastudio.puzzlemania.itemsort.gems_pack_3',
    LARGE: 'puzzlemaniastudio.puzzlemania.itemsort.gems_pack_4',
};
/**
 * Web Billing (Stripe-backed, via RevenueCat) product IDs — a separate catalog from
 * `IAP_PRODUCT_IDS` above, since Stripe's product catalog is independent of Google
 * Play's; the Android ids can't be reused here. These are dictated identifiers, meant
 * to be typed in verbatim when creating the 3 consumable products in RevenueCat's Web
 * dashboard — not reverse-engineered from whatever gets created there. Same tiers, same
 * coin/gem amounts (via the same `REMOTE_CONFIG_KEYS.IAP_PACK_*` values) as the Android
 * catalog — only the underlying product-id strings differ per platform.
 */
export const WEB_IAP_PRODUCT_IDS = {
    SMALL: 'web_small_pack',
    MEDIUM: 'web_medium_pack',
    LARGE: 'web_large_pack',
};
/** The economy sourceId a successful purchase of `productId` credits through — must
 * start with the registered 'shop_' prefix (packages/economy/src/valid-prefixes.ts). */
export function iapSourceIdForProduct(productId) {
    return `shop_iap_${productId}`;
}
